import React from "react";
import {
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
} from "../../../../../components";
import General from "./ClientPlacements/General";
import Payments from "./ClientPlacements/Payments";
import Invoices from "./ClientPlacements/Invoices";
import Documents from "./ClientPlacements/Documents";
import WorkLocation from "./ClientPlacements/WorkLocation";
import TimesheetDetails from "./ClientPlacements/TimesheetDetails";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const AddclientPlacement = ({ onCancel, currentPlacement, editData }) => {
  const location = useLocation();
  const incomingData = location?.state?.incomingData || null;
  const handleBack = () => {
    if (onCancel) {
      onCancel();
    }
  };
  const ClientPlacementMenus = [
    {
      title: "General",
      page: (
        <General
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          editData={editData}
          incomingData={incomingData}
        />
      ),
      type: "main",
    },
    {
      title: "Payments",
      page: (
        <Payments
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          editData={editData}
          incomingData={incomingData}
        />
      ),
      type: "main",
    },
    {
      title: "Timesheet Details",
      page: (
        <TimesheetDetails
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Invoices",
      page: (
        <Invoices
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Documents",
      page: (
        <Documents
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Work Location",
      page: (
        <WorkLocation
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          handleBack={handleBack}
          editData={editData}
        />
      ),
      type: "main",
    },
  ];

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="my-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Client Placement"} tag="h6" />
            </div>
          }
        />
      </div>
      <div className="flex-1 flex overflow-hidden ">
        <NewTab
          tabs={ClientPlacementMenus}
          color="black"
          variant="outlined"
          mode="url"
          tabId="add-client-placement"
        />
      </div>
    </div>
  );
};

export default AddclientPlacement;
